import axios from "axios";

export type UploadProgress = { loaded: number; total?: number };

type CallOptions = {
  /** Reports how much of the request body has been sent (browser only) */
  onUploadProgress?: (event: UploadProgress) => void;
};

/** POST to the API. Resolves with the response body; rejects with the axios error (inspect `response.data`). */
export const callApi = async (endpoint: string, body: Record<string, unknown>, options: CallOptions = {}) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_URL + endpoint,
    data: body,
    ...options,
  });
  return response.data;
};

type StorageTarget = { url: string; fields: Record<string, string> };

/** Sends a file straight to storage with the permission the API handed out; it never passes through the API */
export const uploadToStorage = async (target: StorageTarget, file: File, onUploadProgress?: CallOptions["onUploadProgress"]) => {
  const form = new FormData();
  Object.entries(target.fields).forEach(([name, value]) => form.append(name, value));
  // Storage ignores everything after the file field, so it has to come last
  form.append("file", file);
  await axios.post(target.url, form, { onUploadProgress });
};
